<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="历史审核记录"
      id="topbar"
      style="background-color: #4263EB"
    >
      <template #right>
        <div style="border: 0px solid;line-height: 50px">
          <van-icon name="chat-o" :badge="notReadMessageCount" v-if="notReadMessageCount!==0" size="25" @click="$router.push({name:'common-messageList'})" />
          <van-icon name="chat-o" v-else size="25" @click="$router.push({name:'common-messageList',params:{backPath:'feature-record'}})" />
        </div>
      </template>
    </van-nav-bar>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="volume-o" style="margin-top:-2px;position: fixed;width: 100%;z-index: 9999" scrollable :text="messageText" v-if="notReadMessageCount!==0" />
    <div style="height: 30px" v-if="notReadMessageCount!==0"></div>

      <van-list
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getData"

      >
        <van-cell v-for="(item,index) in list" v-if="list.length>0"   :key="index" style="border: 1px solid #CECECE;width: 90%;margin: 0px auto;margin-top: 20px;height: 220px;overflow: auto" :style="{height: item.operator!=='0'?'250px':'220px'}">
          <div style="text-indent: 20px">
            申请时间：{{item.createTime}}
          </div>
          <div style="text-indent: 20px">
            点位：{{item.pointName}}
          </div>
          <div style="text-indent: 20px">
            代码：{{item.pointCode}}
          </div>
          <div style="text-indent: 20px">
            任务：{{item.taskName}}
          </div>
          <div style="text-indent: 20px">
            区域：{{item.districtName}}/{{item.townName}}
          </div>
          <div style="text-indent: 20px">
            地址：{{item.pointAddress}}
          </div>
          <div style="text-indent: 20px">
            检查员：{{item.checkUserName}}
          </div>
          <div style="text-indent: 20px">
            审核人：{{item.reviewUserName}}
          </div>
          <div style="text-indent: 20px" v-if="item.operator!=='0'">
            拒绝理由：{{item.message}}
          </div>
          <div style="position: relative;left:80%;top:-50%;width: 50px">
            <van-icon name="success" color="green" v-if="item.operator==='0'" size="40" />
            <van-icon name="cross" color="red" v-else size="40" />
          </div>
        </van-cell>
        <div style="width: 100%;height: 500px;text-align: center;" v-else>
          <van-empty  description="暂无数据......" />
        </div>
      </van-list>






    <van-popup v-model="show" position="bottom" closeable :style="{ height: '40%' }" close-icon-position="top-right" >
      <br>
      <div style="width: 200px;margin: 0px auto;text-align: center;">
        <span style="font-size: 20px;font-weight: bold">拒绝申请</span>
      </div>
      <br>
      <div style="height: 200px;overflow: auto">
        <van-field
          v-model="message"
          rows="2"
          autosize
          label="拒绝理由："
          type="textarea"
          maxlength="200"
          placeholder="请输入拒绝理由"
          show-word-limit
          style="font-size: 16px"
        />
      </div>
      <div style="height: 40px;width: 200px;margin: auto">
        <el-button type="primary"  round style="border-radius: 15px;height: 40px;width: 200px;font-size: 16px" @click="submitNotPass">提交</el-button>
      </div>
    </van-popup>





    <van-tabbar v-model="active">
      <van-tabbar-item to="../reviewRecord">
        <span>待审核记录</span>
        <template #icon="props">
          <img :src="props.active ? icon.homeInActive : icon.homeActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="record">
        <span>历史审核记录</span>
        <template #icon="props">
          <img :src="props.active ? icon.featureInActive : icon.featureActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../common/reviewMe">
        <span>我的信息</span>
        <template #icon="props">
          <img :src="props.active ? icon.meInActive : icon.meActive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import $ from '@/fly'
import {Toast} from "vant";
import {recMsg} from "@/api/module/message/message";
export default {
  name: "record",
  data(){
    return {
      clientHeight: window.screen.height,
      clientWidth: window.screen.width,
      active: 1,
      icon: {
        homeInActive: require('../../../assets/inHomeIcon.svg'),
        homeActive: require('../../../assets/homeIcon.svg'),
        meInActive: require('../../../assets/inMeIcon.svg'),
        meActive: require('../../../assets/meIcon.svg'),
        featureActive: require('../../../assets/proIcon.svg'),
        featureInActive: require('../../../assets/inProIcon.svg')
      },
      list: [],
      error: false,
      show: false,
      message: '',
      item: {},
      notReadMessageCount:0,
      userInfo:{},
      messageText:'',
      isLoading: false,
    }
  },
  methods:{
    onRefresh(){
      this.list = []
      this.getData()
      Toast("刷新成功")
    },
    callPhone (phoneNumber) {
      /**
       * 点位联系人电话 1.手机号 2.固话: 0XXX-XXXXXXXX-XXXXXX（多个）
       */
      window.location.href = 'tel://' + phoneNumber
    },

    submitNotPass(){
      $.put('/mobile/applyReject',{
        message: this.message,
        taskId: this.item.taskId,
        pointId: this.item.pointId,
        checkUser: this.item.checkUser
      }).then(res=>{
        Toast.success('提交成功');
        this.show = false
        this.getData()
      })
    },

    pass(item){
      console.log('pass',item)
      this.item = item
      $.put('/mobile/applyPass',{
        taskId: this.item.taskId,
        pointId: this.item.pointId,
      }).then(res=>{
        Toast.success('审核成功');
        this.getData()
      })
    },

    notPass(item){
      console.log('notPass',item)
      this.item = item
      this.show = true
    },

    getData(){
      let queryData = {}
      $.get('/mobile/getReviewRecordList',queryData).then(res=>{
        this.list = res
        this.isLoading = false
      }).catch(err=>{
        this.error = true
      })
    },
    //查询未读消息
    getMessageList(){
      recMsg(this.userInfo.userId,1,false).then(res=>{
        this.notReadMessageCount = res.total
        if(this.notReadMessageCount!==0){
          this.messageText = this.formatTimestamp(res.rows[0].sendTime)+'：'+res.rows[0].content
        }
      })
    }
    ,
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('USER'));
    console.log('user',this.userInfo)
    this.getMessageList()
  }
}
</script>

<style scoped>

</style>
